import { Subject } from 'rxjs';
import { GameLogicBuilder } from '../logic/game-logic-builder';
import { SolitaireGameRound } from './solitaire-game-round';
import { SolitaireLocalRoundParams } from './solitaire-local-round-params';
import { SolitaireRemoteRoundParams } from './solitaire-remote-round-params';
import { SolitaireListener } from '../game/solitaire-listener';
import { GameState } from 'game-logic';
import { GameRound } from 'src/games/common/phaser/model/game-round';
import { RoundParams } from 'src/games/common/phaser/model/round-params';

export class SolitaireRoundCreator {
  public get currentRound(): SolitaireGameRound | undefined {
    return this._currentRound;
  }
  public get onBoardChangedTrigger() {
    return this.onBoardChanged.asObservable();
  }
  public get onGameStateChangedTrigger() {
    return this.onGameStateChanged.asObservable();
  }

  private onBoardChanged: Subject<void>;
  private onGameStateChanged: Subject<GameState>;
  private _currentRound: SolitaireGameRound | undefined;

  constructor(private solitaireListener: SolitaireListener) {
    this.onBoardChanged = new Subject();
    this.onGameStateChanged = new Subject();
  }

  public startNewRound(roundParams: RoundParams): GameRound {
    let nextRound: SolitaireGameRound;
    if (SolitaireRemoteRoundParams.isRound(roundParams)) {
      nextRound = this.createRemoteRound(roundParams);
    } else if (SolitaireLocalRoundParams.isRound(roundParams)) {
      nextRound = this.createLocalRound(roundParams);
    } else {
      throw new Error('Failed to create new round');
    }

    nextRound.onBoardChangedAction = () => {
      this.onBoardChanged.next();
    };
    nextRound.onGameStateChangedAction = (state) => {
      this.solitaireListener.onGameStateChange(state);

      this.onGameStateChanged.next(state);
    };
    nextRound.onCommandCommittedAction = (moves) => {
      this.solitaireListener.onNewMove(moves);
    };
    nextRound.onScoreChangedAction = (score) => {
      this.solitaireListener.onScoreChange(score);
    };

    this._currentRound = nextRound;
    return nextRound;
  }

  private createRemoteRound(remoteRoundParams: SolitaireRemoteRoundParams): SolitaireGameRound {
    return new SolitaireGameRound(
      GameLogicBuilder.newGame(remoteRoundParams.dealer, remoteRoundParams.logicVersion),
      remoteRoundParams.roundResultSubmitter,
    );
  }

  private createLocalRound(localRoundParams: SolitaireLocalRoundParams): SolitaireGameRound {
    return new SolitaireGameRound(
      GameLogicBuilder.newGame(localRoundParams.dealer, localRoundParams.logicVersion),
      localRoundParams.roundResultSubmitter,
    );
  }
}
